import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';

// import { goAuth } from '../../../pages/auth/authActions';
// import MessagesMenu from '../../../containers/MessagesMenu/MessagesMenu';
// import NotificationMenu from '../../../containers/NotificationMenu/NotificationMenu';
// import TasksMenu from '../../../containers/TasksMenu/TasksMenu';
// import UserMenu from '../../../containers/UserMenu/UserMenu';

class Navbar extends Component {

	render() {
		return (
			<div className="navbar-custom-menu">
				<ul className="nav navbar-nav">
					{/* <MessagesMenu  />
					<NotificationMenu />
					<TasksMenu /> */}
					{/* <UserMenu /> */}
				</ul>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		// user: state.auth.user
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);